import createStore from "astrid-helpers/src/createStore";

import { onUser } from "../../authentication/state/user";

export const [
	getOrganizationType,
	setOrganizationType,
	useOrganizationType,
	onOrganizationType,
	resetOrganizationType,
] = createStore();

onUser((user, previousUser) => {
	if (previousUser && user?.uid !== previousUser.uid) {
		resetOrganizationType();
	}
});
